import BarChart from '../../../../components/BarChart';
import Detail from '../../../../components/Detail';
import { formatAmountWithSuffix } from '../../../../helpers/formats';
import useTotalStakedSpool from '../../../../hooks/web3/vault/useTotalStakedSpool';
import useTotalSpoolCirculatingSupply from '../../../../hooks/web3/vault/useTotalSpoolCirculatingSupply';

const StakedByCommunity = () => {
    const { totalStakedSpool } = useTotalStakedSpool();

    const { totalSpoolCirculatingSupply } = useTotalSpoolCirculatingSupply();

    return (
        <Detail
            title={`Staked by Community`}
            value={
                <>
                    <div>
                        {formatAmountWithSuffix(totalStakedSpool || 0)}/
                        {formatAmountWithSuffix(totalSpoolCirculatingSupply || 0)} $SPOOL
                    </div>
                    <BarChart
                        value={totalStakedSpool || 0}
                        total={totalSpoolCirculatingSupply || 0}
                    />
                </>
            }
        />
    );
};

export default StakedByCommunity;
